import styles from './MapHeader.module.css';


const MapHeader = ({activeMenu, selectedOption, setSelectedOption, setSelectedHotple, mapHotples, mapLocation, setIsSearchMode, setInfoModalPage, setUserModalPage, periodHotpleGroup, marginTop, isLimited}) => {
	const handleLimitBadgeClicked = (event) => {
		event.stopPropagation();
		setUserModalPage(4);
	};

	function whenCategoryClicked(category){
		setSelectedOption((prev)=>({...prev, category: category, sub_category: 'all'}));
		setSelectedHotple(null);
	}

  	return (
    		<div style={{marginTop: `${marginTop}px`}} className={styles.mapHeader}>
      			<div className={styles.locationSearchBar} onClick={()=>setIsSearchMode(true)}>
					<div className={styles.div}>
						<div className={styles.div1}>{mapLocation.name || mapLocation.address}</div>
						<img className={styles.iconchevronBottom} alt="" src="images/chevron_bottom.svg" />
						<div className={styles.km}>핫플 {mapHotples.hotples.length}개</div>
						{activeMenu == 'search' && isLimited &&
							<div className={'buttonBadge'} style={{top:'6px',right:'12px'}} onClick={handleLimitBadgeClicked}>검색결과 제한됨</div>
						}
					</div>
					<div className={styles.right}>
						<div className={styles.div2}>
								<img className={styles.iconsearch} alt="" src="images/search.svg" />
						</div>
					</div>
      			</div>
      			<div className={styles.categorybuttons}>
					<div className={styles.div3}>
						<div className={styles.list}>
							<div className={`${selectedOption.category === 'recommend' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('recommend')}>
								<img className={styles.iconstarFilled} alt="" src="images/star_filled.svg" />
								<div className={styles.label}>{activeMenu=='my' || activeMenu=='admin' ? "전체" : "추천"}</div>
							</div>
							<div className={`${selectedOption.category === 'restaurant' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('restaurant')}>
								<img className={styles.iconstarFilled} alt="" src="images/restaurant.svg" />
								<div className={styles.label}>음식점</div>
							</div>
							<div className={`${selectedOption.category === 'alcohol' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('alcohol')}>
								<img className={styles.iconstarFilled} alt="" src="images/alcohol.svg" />
								<div className={styles.label}>주점</div>
							</div>
							<div className={`${selectedOption.category === 'cafe' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('cafe')}>
								<img className={styles.iconstarFilled} alt="" src="images/cafe.svg" />
								<div className={styles.label}>카페/디저트</div>
							</div>
							<div className={`${selectedOption.category === 'activity' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('activity')}>
								<img className={styles.iconstarFilled} alt="" src="images/activity.svg" />
								<div className={styles.label}>오락/액티비티</div>
							</div>
							<div className={`${selectedOption.category === 'cultural' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('cultural')}>
								<img className={styles.iconstarFilled} alt="" src="images/smile.svg" />
								<div className={styles.label}>문화/예술</div>
							</div>
							<div className={`${selectedOption.category === 'popupStore' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('popupStore')}>
								<img className={styles.iconstarFilled} alt="" src="images/popupStore.svg" />
								<div className={styles.label}>팝업스토어</div>
							</div>
							<div className={`${selectedOption.category === 'rest' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('rest')}>
								<img className={styles.iconstarFilled} alt="" src="images/flower.svg" />
								<div className={styles.label}>휴식/힐링</div>
							</div>
							<div className={`${selectedOption.category === 'accommodation' ? styles.buttonplaceCategorySelected : styles.buttonplaceCategory}`} onClick={() => whenCategoryClicked('accommodation')}>
								<img className={styles.iconstarFilled2} alt="" src="images/home_filled.svg" />
								<div className={styles.label}>숙소</div>
							</div>
							{periodHotpleGroup.map((group)=>{return (
								<img key={group.name} className={styles.hotpleGroup} alt="" src={group.button_image_url} onClick={() => whenCategoryClicked(`@${group.name}`)}/>
							)})}
							{activeMenu=='admin' &&
								<div className={styles.buttonplaceCategoryPeriod} onClick={() => setInfoModalPage(21)}>
									<div className={styles.label}>+ 기간 카테고리</div>
								</div>
							}
						</div>
					</div>
      			</div>
    		</div>);
};

export default MapHeader;
